/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

 export const ZoomInIconUrl = 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltc1267b7e6c1f5862/627194a5bae21939d5444f5f/ZoomIn_white.svg';